
//
// Current build version
// Note: Do not change this file manually, it's overridden by esbuild
//
export const EdstartVersion = {
  "buildHash": "f5bad699e333ffcca2fc85c0d36de2afad3ac053",
  "buildsTs": "2023-02-17_075443"
}
